import { render } from "./HomeworkAdd.vue?vue&type=template&id=05ece231&scoped=true"
import script from "./HomeworkAdd.vue?vue&type=script&lang=js"
export * from "./HomeworkAdd.vue?vue&type=script&lang=js"

import "./HomeworkAdd.vue?vue&type=style&index=0&id=05ece231&lang=css"
import "./HomeworkAdd.vue?vue&type=style&index=1&id=05ece231&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ece231"]])

export default __exports__